<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Modifier Gamme Produit </strong>
          </div>
          <b-form>
            <b-form-group label="Libellé" label-for="libelle">
              <b-form-input
                id="libelle"
                type="text"
                :class="{hasError: errors.libelle !== ''}"
                v-model="libelle"
              />
              <span class="field-error">{{ errors.libelle }}</span>
            </b-form-group>
            <b-form-group label="Visible dans la Bibliothèque" label-for="bibliotheque_dgpo">
              <b-form-radio v-model="isVisibleBibliothequeDgpo" name="bibliotheque_dgpo" value="true">Oui</b-form-radio>
              <b-form-radio v-model="isVisibleBibliothequeDgpo" name="bibliotheque_dgpo" value="false">Non</b-form-radio>
            </b-form-group>
            <b-form-group label="Module Contrat" label-for="module_contrat">
              <b-form-radio v-model="isVisibleModuleContrat" name="module_contrat" value="true">Oui</b-form-radio>
              <b-form-radio v-model="isVisibleModuleContrat" name="module_contrat" value="false">Non</b-form-radio>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox-group
                id="checkbox-group-secteur"
                v-model="selectedSecteur"
                aria-describedby="choix secteur ESS et/ou Interpro"
                name="secteur"
              >
                <b-form-checkbox value="ess">ESS</b-form-checkbox>
                <b-form-checkbox value="interpro">INTERPRO</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <b-form-group label="Remarque" label-for="remarque">
              <b-form-input
                id="remarque"
                type="text"
                :class="{hasError: errors.remarque !== ''}"
                v-model="remarque">
              </b-form-input>
            </b-form-group>
            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des gammes produit
              </b-button>
              <b-button type="button" @click="save" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
  import { isEmpty } from "@/utils/fileHelper"

  export default {
    name: "Edit",
    data() {
      return {
        libelle: "",
        isVisibleBibliothequeDgpo: "0",
        isVisibleModuleContrat: "0",
        selectedSecteur: [],
        remarque: "",
        errors: {
          libelle: "",
          remarque: "",
        },
      }
    },
    mounted() {
      this.id = this.$route.params.id;
      this.getGammeProduit();
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      getGammeProduit() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/produit/gestion-gamme/' + this.id)
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            this.libelle = response.data.gammeProduit.libelle;
            this.isVisibleBibliothequeDgpo = response.data.gammeProduit.is_visible_biliotheque_dgpo;
            this.isVisibleModuleContrat = response.data.gammeProduit.is_visible_module_contrat;
            this.remarque = response.data.gammeProduit.remarque;
            if (response.data.gammeProduit.secteur.match(/ess/g)) {
              this.selectedSecteur.push('ess');
            }
            if (response.data.gammeProduit.secteur.match(/interpro/g)) {
              this.selectedSecteur.push('interpro');
            }
          })
          .catch((error) => {
            console.log(error)
            this.handleError(error);
          });
      },
      save() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let dataPost = {};
          dataPost.libelle = this.libelle;
          dataPost.isVisibleBibliothequeDgpo = this.isVisibleBibliothequeDgpo;
          dataPost.isVisibleModuleContrat = this.isVisibleModuleContrat;
          dataPost.remarque = this.remarque;
          dataPost.secteur = this.selectedSecteur;
          this.$axios
            .put("/espaceGestion/produit/gestion-gamme/" + this.id, dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Modification avec succès",
                text: "La gamme produit a été bien modifiée ",
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack();
            })
            .catch(() => {
              this.$store.commit("IS_LOADING", false);
              this.handleError(this);
            });
        }
      },
      returnBack() {
        this.$router.push({path: "/espace-gestion/produit/gestion-gamme/list"});
      },
      validateData() {
        this.clearErrors()
        let valid = true;
        if (isEmpty(this.libelle)) {
          this.errors.libelle = "Le libellé est obligatoire";
          valid = false;
        }
        else if (isEmpty(this.remarque)) {
          this.errors.remarque = "Le remarque est obligatoire";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.libelle = "";
        this.errors.remarque = "";
      },
      handleError() {
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter l\'administrateur',
          showConfirmButton: false,
          timer: 5000,
        });
      }
    }
  }
</script>
